import { Result, Typography } from 'antd';
const { Paragraph, Text } = Typography;

import React from 'react';

import { isNotNull } from '@totem/utilities/common';

type Props = {
  title: string;
  subTitle?: string;
  actionButtons?: React.ReactNode[];
  children?: React.ReactNode;
};

const Failed = ({ title, subTitle, children, actionButtons }: Props) => {
  return (
    <Result
      status="error"
      title={title}
      subTitle={isNotNull(subTitle) ? subTitle : null}
      extra={isNotNull(actionButtons) ? actionButtons : []}
    >
      {isNotNull(children) && (
        <div className="desc">
          <Paragraph>
            <Text
              strong
              style={{
                fontSize: 16,
              }}
            >
              {children}
            </Text>
          </Paragraph>
        </div>
      )}
    </Result>
  );
};

export default Failed;
